import client from "@lab/api/httpClient";
import { UserDetails, UserLogin } from "@lab/types/users";

export const tokenType = {
	invite: "invite",
	passwordReset: "password_reset"
};

export const authentication = {
	login: async (details: UserLogin): Promise<UserDetails | undefined> => {
		const response = await client.post(`/auth/login`, details);
		return response.data as UserDetails;
	},
	resetpassword: async (details): Promise<undefined> => {
		const response = await client.post(`/auth/resetpassword`, details);
		return response.data as undefined;
	},
	setpassword: async (details): Promise<undefined> => {
		const response = await client.post(`/auth/setpassword`, details);
		return response.data as undefined;
	},
	validateToken: async (details): Promise<string | undefined> => {
		const response = await client.post(`/auth/validtoken`, details);
		return response.data as string;
	},
	confirmInvite: async (details): Promise<string | undefined> => {
		const response = await client.post(`/auth/invite`, details);
		return response.data as string;
	}
};

export default { authentication };
